function WIaccessibility() {

    var $items = $('.navbar-nav > li, .navbar-extra > li').filter(function () {
        return $(this).children('.submenu').length > 0;
    });

    $items.each(function (index) {
        var $li = $(this),
            $submenu = $li.children('.submenu').first(),
            $trigger = $li.children('.navbar-clickable, a').first();

        if (!$trigger.length) {
            return;
        }

        var submenuId = $submenu.attr('id');
        if (!submenuId) {
            submenuId = 'wi-submenu-' + index;
            $submenu.attr('id', submenuId);
        }

        $trigger.attr('aria-controls', submenuId);
        $trigger.attr('aria-expanded', $submenu.hasClass('sys') ? 'true' : 'false');
    });

    if (window.MutationObserver) {
        $items.children('.submenu').each(function () {
            var submenu = this;
            new MutationObserver(function () {
                var $submenu = $(submenu),
                    expanded = $submenu.hasClass('sys');
                $submenu.closest('li').children('.navbar-clickable, a').first()
                    .attr('aria-expanded', expanded ? 'true' : 'false');
            }).observe(submenu, {attributes: true, attributeFilter: ['class']});
        });
    }

    $(document).on('keydown.wiaccessibility', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            var $openSubmenu = $items.children('.submenu.sys').first();
            if ($openSubmenu.length) {
                var $trigger = $openSubmenu.closest('li').children('.navbar-clickable, a').first();
                $openSubmenu.removeClass('sys');
                bd.removeClass('menu-open').hide();
                $trigger.focus();
            }
        }
    });

    var pointerInMenu = false;
    $items.on('mousedown.wiaccessibility', function () {
        pointerInMenu = true;
    });
    $(document).on('mouseup.wiaccessibility', function () {
        pointerInMenu = false;
    });

    $items.on('focusout.wiaccessibility', function () {
        var li = this;
        var clickInsideMenu = pointerInMenu;
        setTimeout(function () {
            if (clickInsideMenu) {
                return;
            }
            if (!li.contains(document.activeElement)) {
                var $submenu = $(li).children('.submenu').first();
                if ($submenu.hasClass('sys')) {
                    $submenu.removeClass('sys');
                    bd.removeClass('menu-open').hide();
                }
            }
        }, 0);
    });

    var $html = $('html'),
        navKeys = {
            Tab: 1, ArrowUp: 1, ArrowDown: 1, ArrowLeft: 1, ArrowRight: 1,
            Home: 1, End: 1, PageUp: 1, PageDown: 1, Escape: 1
        };

    $(document).on('keydown.wiaccessibility-modality', function (e) {
        if (navKeys[e.key] || e.keyCode === 9) {
            $html.addClass('wi-keyboard-nav');
        }
    });

    $(document).on('mousedown.wiaccessibility-modality pointerdown.wiaccessibility-modality touchstart.wiaccessibility-modality', function () {
        $html.removeClass('wi-keyboard-nav');
    });
}

function menu() {
    $('.menu').click(function () {
        if (!$('html').hasClass('menu-open') && !$('.backdrop').hasClass('menu-open')) {
            $('html').addClass('menu-open');
            bd.fadeIn();
        } else {
            $('html').removeClass('menu-open');
            bd.fadeOut();
        }
    });
}

function submenu() {
    $('.navbar-nav li > a, .navbar-nav li > .navbar-clickable, .navbar-extra li > a, .navbar-extra li > button').click(function (e) {

        if ($(this).parent().find('.submenu').length) {
            e.preventDefault();
            $('.popup').removeClass('active');
        }

        if ($(this).parent().find('.submenu').length) {
            if (!$(this).parent().find('.submenu').hasClass('sys')) {
                $('.submenu').removeClass('sys');
                $(this).parent().find('.submenu').addClass('sys');
                bd.removeAttr('style').addClass('menu-open').show();
            } else {
                $(this).parent().find('.submenu').removeClass('sys');
            }
        }

        if ($(this).parent().find('.navbar__nav-submenu').length) {
            if (!$(this).parent().find('.navbar__nav-submenu').hasClass('sys')) {
                $(this).parents('li').addClass('sys');
                $(this).parent().find('.navbar__nav-submenu').addClass('sys').slideDown();
            } else {
                $(this).parents('li').removeClass('sys');
                $(this).parent().find('.navbar__nav-submenu').removeClass('sys').slideUp();
            }
        }
    });
}

function form() {
    var donablyUrl = window.parent.location.origin;

    $('.form-group').off().on('click', function (e) {
        var self = $(this);

        if (!$(e.target).hasClass('tooltip-trigger')) {
            if ($(self).find('input#organization').length) {
                if ($(self).find('input#organization').prop('checked') == true) {
                    $('.form-group-organization').slideDown();
                    $('.form-group-organization input[type="text"]').attr('required', 'required');
                } else {
                    $('.form-group-organization').slideUp();
                    $('.form-group-organization input[type="text"]').removeAttr('required');
                }
            }
            setTimeout(function () {
                $(self).addClass('active');
            }, 10);
        }
    });

    $('.form-groups-recurring input').on('change', function () {
        if ($(this).prop('checked') === true) {
            $(this).parents('.form-group').addClass('is-opened');
        } else {
            $(this).parents('.form-group').removeClass('is-opened');
        }
    })
    $('.form-control-recurring').on('change', function () {
        if ($(this).prop('checked') === true) {
            $(this).parents('.form-group').find('.form-group-recurring').css('display', 'flex');
            $(this).parents('.form-group').find('.form-group-recurring input').attr('required', 'required');
            $('.form-control-recurring-monhtly').attr('checked', 'checked');
        } else {
            $(this).parents('.form-group').find('.form-group-recurring')
                .css('display', 'none')
                .find('input')
                .removeAttr('required')
                .prop('checked', false);
        }
    })

    $(doc).on('click', '.form-control', function () {
        if (!$(this).parent().hasClass('active')) {
            $('.form-group').removeClass('active');
            $(this).parent().addClass('active');
        }
    }).on('keyup', '.form-control', function () {
        if ($(this).val() != '') {
            $(this).parent().addClass('has-value');
        } else {
            $(this).parent().removeClass('has-value');
        }
    });

    $('.issue-an-invoice').on('change', function () {
        if ($(this).prop('checked') == true) {
            $('.tab-other-billing-invoice').slideDown();
        } else {
            $('.tab-other-billing-invoice').slideUp();
        }
    }).each(function () {
        if ($(this).prop('checked') == true) {
            $('.tab-other-billing-invoice').show();
        }
    });

    $('.form-control').not('.form-control-layout').each(function (i, v) {
        var val = $(v).val();
        if ((val && val.length >= 1) || $(v).text() >= 1) {
            $(v).trigger('change');
            $(v).parent().addClass('has-value').removeClass('active');
        }
    });

    $('.form-character-limit').each(function (i, v) {
        var $field = $(v),
            max = parseInt($field.data('max'), 10);

        if (!max || max < 1) {
            return;
        }

        var counterSelector = $field.data('counter'),
            $counter = $();

        if (counterSelector) {
            var $scope = $field.closest('.form-group');
            $counter = ($scope.length ? $scope : $field.parent()).find(counterSelector).first();
        }

        $field.attr('maxlength', max);

        function update() {
            var val = $field.val() || '';

            if (val.length > max) {
                val = val.substring(0, max);
                $field.val(val);
            }

            if ($counter.length) {
                $counter.text(val.length);
            }
        }

        $field.on('input change paste drop', function () {
            setTimeout(update, 0);
        });

        update();
    });

    function formatState(state) {
        if (!state.id) {
            return state.text;
        }
        var baseUrl = "https://flagicons.lipis.dev/flags/4x3";
        var $state = $('<span><img src="' + baseUrl + '/' + state.element.value.toLowerCase() + '.svg" class="img-flag" width="20" height="15" alt="' + state.text + '" title="' + state.text + '"/> ' + state.text + '</span>');
        return $state;
    }

    let textDelete = $('.add-container').data('delete-text');

    $('.form-control-select').not('.form-control-pw').each(function (i, v) {
        $(v).addClass('form-control-select-' + i);

        if ($(v).data('spec') == 'image') {
            $(v).select2({
                containerCssClass: 'asd',
                dropdownCssClass: $('.form-control-select-' + i).data('customclass'),
                language: lang,
                templateResult: formatState,
            }).on('select2:open', function () {
                if ($('.form-countrycode').length) {
                    $('.form-countrycode').parent().addClass('select2-container-countrycode');
                }
            }).on('select2:select', function (e) {
                $('.form-control-select-' + i).parents('.form-group').addClass('has-value').removeClass('active has-error');


                let text = $(this).find('option:selected').data('code');
                let img;

                if ($('#select2-countrycode-reg-container').length) {
                    img = 'https://flagicons.lipis.dev/flags/4x3/' + $(this).val() + '.svg';

                    $('#select2-countrycode-reg-container').html('<img src="' + img.toLowerCase() + '" width="20" height="15" alt="' + text + '" title="' + text + '"/>' + text);

                }

                if ($('#select2-countrycode-container').length && !$('#select2-countrycode-reg-container').length) {
                    img = 'https://flagicons.lipis.dev/flags/4x3/' + $(this).val() + '.svg';

                    $('#select2-countrycode-container').html('<img src="' + img.toLowerCase() + '" width="20" height="15" alt="' + text + '" title="' + text + '"/>' + text);
                }

            }).on('focus').val(null).trigger('change');
        } else {
            $(v).select2({
                dropdownCssClass: $('.form-control-select-' + i).data('customclass'),
                width: '100%',
                language: lang,
                minimumResultsForSearch: $(v).hasClass('no-search') ? Infinity : 0,

            }).on('select2:select', function () {
                $('.form-control-select-' + i).parents('.form-group').addClass('has-value').removeClass('active has-error');

                if ($('#socials').length && $(this).attr('id') == 'socials') {
                    var label = $('#socials').val(), number = $('body').find('.clone-area .form-group .form-control').length + 1, url = $(this).find('option:selected').data('url');

                    $('#socials').parent().slideUp();
                    $('.clone-area').append('<div class="form-group form-group-full form-group-social hys has-value"> ' + '<label class="form-label" for="added-input-' + number + '">' + label + '</label> ' + '<div class="form-control"><p>' + url + '</p>' + '<input type="text" class="form-control-simple" name="added-input-' + number + '" id="added-input-' + number + '" required/> ' + '<button type="button" class="delete-url delete-added-url"><img src="' + donablyUrl + '/public/img/icons/delete-red.svg"' +
                        ' width="45" height="45" alt="' + textDelete + '" title="' + textDelete + '"/></button></div>' + '</div>');
                    $('#added-input-' + number).focus();
                }
            }).on('select2:open', function () {
                setTimeout(function () {
                    document.querySelector('.select2-search__field').focus();
                }, 100);
            }).on('select2:close', function () {
                if ($('#socials').length) {
                    setTimeout(function () {
                        $('#socials').val(null).trigger('change');
                    }, 100);
                }
            }).on('focus');
        }
    });

    $('body').off().on('click', '.select2.select2-container', function () {
        $(this).parent().find('.form-control-select').select2('focus');
    });

    $(doc).on('click', '.form-label-select', function () {
        $(this).parent().find('.form-control-select').select2('open');
    });

    if ($('.form-group-slider p span i').length) {
        let width = $('.form-group-slider p span i').width() + 20;
        $('.form-group-slider p span i').css('right', width * -1);
    }
}

function datepicker() {
    $('.datepicker').datepicker({
        language: lang,
        autoclose: true,
        format: 'yyyy. mm. dd.',
        weekStart: 1,
        orientation: 'auto',
        todayHighlight: true
    }).on('changeDate', function (e) {
        $(e.delegateTarget).parents('.form-group').removeClass('has-error').addClass('has-value');
        $('.form-group.form-radio').find('.timepicker').val('00:00');
    });
}

function paywallBilling() {
    if ($('.paywall-taxnumber').length) {
        var taxFormat = $('.paywall-taxnumber').data('numberformat');
        $('.paywall-taxnumber').inputmask(taxFormat);
    }
}

function createNotification(text, source) {
    let title = $('#custom_donation_error_title').val();
    $('body').append('<div class="notification notification-dismiss notification-success">' + '<img src="../public/img/icons/close-border.svg" class="notification-close" width="34" height="34" alt="" title=""/>' + '<div><p>' + title + '</p><span>' + text + '</span></div>' + '</div>');

    setTimeout(function () {
        $('.notification').addClass('sys');
    }, 100);
    setTimeout(function () {
        $(source).removeClass('disable');
    }, 4000);
    setTimeout(function () {
        $('.notification').remove();
    }, 15000);

}

function createPopup(title, text, button) {
    $('body').append('<div class="tr-600 popup popup-600 popup-general"> ' + '<div class="popup-inner">' + '<div class="popup-close"><img src="../public/img/icons/close.svg" width="34" height="34" alt="" title=""/></div> ' +

        '<div class="popup-content"> ' + '<h2 class="h1 text-center">' + title + '</h2> ' + '<p>' + text + '</p> ' + '<a href="javascript:void(0)" class="btn btn-border btn-border-turquoise btn-big btn-anim popup-dismiss" title="' + button + '">' + '<span class="bg"></span>' + '<span class="text">' + button + '</span>' + '</a>' + '</div> ' + '</div>');

    showPopup('general');
}

function createDismissableNotification(text) {
    let title = $('#custom_donation_error_title').val();
    $('body').append('<div class="notification notification-dismiss notification-success">' + '<img src="../public/img/icons/close-border.svg" class="notification-close" width="34" height="34" alt="" title=""/>' + '<div><p>' + title + '</p><span>' + text + '</span></div>' + '</div>');

    setTimeout(function () {
        $('.notification').addClass('sys');
    }, 100);
    setTimeout(function () {
        $('.notification').remove();
    }, 5000);

}

function closeNotification() {
    $(doc).on('click', '.notification-close', function () {
        $('.notification-dismiss').addClass('hys');

        setTimeout(function () {
            $('.notification-dismiss').remove();
        }, 3000);
    });
}

function showCustomBlock() {
    $('.js-showcustomblock').change(function () {
        if ($(this).prop('checked') == true) {
            $('.custom-blocktemplate').show();
            $('.custom-block-amountname').attr('required', 'required');
            $(doc).animate({'scrollTop': $('.custom-blocktemplate').offset().top - $('.navbar').height() - 60}, 1000);
        } else {
            $('.custom-block-amountname').removeAttr('required');
            $('.custom-blocktemplate').hide();
        }
    });

    $('.js-hide-custom').click(function () {
        $('.js-showcustomblock').prop('checked', false).trigger('change');
    });

    if ($('.js-hide-package').length) {
        $('.js-hide-package').click(function () {
            $('.js-showcustomblock').prop('checked', false).trigger('change');
        });
    }

}

function accordion() {
    $(doc).on('click', '.gyik-item-title', function () {
        var self = $(this);

        if (!$(this).hasClass('active')) {
            $(this).parent().find('.gyik-item-title, .gyik-item-txt').removeClass('active');
            $(this).parent().find('.gyik-item-txt').slideUp();
            $(self).addClass('active');
            $(self).next().addClass('active ').slideDown();
        }
    });

    $('.gyik-item-title').each(function (i, v) {
        if ($(v).hasClass('active')) {
            $(v).next().addClass('active').show();
        }
    });
}

function addUrl() {
    $('.add-page').click(function () {
        $(this).parents('.page-settings-social').find('.input-urls').slideDown(function () {
            $('#socials').select2('open');
        });
    });
}

function deleteAddedUrl() {
    $(doc).on('click', '.delete-added-url', function () {
        $(this).parents('.form-group-social.hys').remove();
    });
}

function checkInputContent() {
    $('.input-check').keyup(function () {
        var self = $(this), selfVal = $(self).val(), target = $(self).data('target'), textTarget = $(self).data('texttarget');

        if ($(self).val() != '') {
            if (textTarget) {
                $(textTarget).text(selfVal);
            }
            if (target) {
                $(target).find('.edit').addClass('edited');
            } else {
                $(self).parent().find('.edit').addClass('edited');
            }
        } else {
            if (textTarget) {
                $(textTarget).html('&nbsp;');
            }
            if (target) {
                $(target).find('.edit').removeClass('edited');
            } else {
                $(self).parent().find('.edit').removeClass('edited');
            }
        }
    }).each(function () {
        var self = $(this), selfVal = $(self).val(), target = $(self).data('target'), textTarget = $(self).data('texttarget');

        if ($(self).val() != '') {
            if (textTarget) {
                $(textTarget).text(selfVal);
            }
            if (target) {
                $(target).find('.edit').addClass('edited');
            } else {
                $(self).parent().find('.edit').addClass('edited');
            }
        }
    });
}

function focusInputContent() {
    $('.edit').click(function () {
        var self = $(this), target = $(self).data('target');

        if (target) {
            $('body').animate({'scrollTop': $('#' + target).parent().offset().top - $('.navbar').height() - 60}, '1000');
            $('#' + target).parent().find('input').focus();
        } else {
            $(self).parents('.input-group').find('.input-check').focus();
        }
    });
}

function passwordChecker() {
    $('.form__passwordcheck').removeClass('check');

    let specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,./~`-=";
    let check = function (string) {
        for (i = 0; i < specialChars.length; i++) {
            if (string.indexOf(specialChars[i]) > -1) {
                return true;
            }
        }
        return false;
    };

    $('input[type=password]').keyup(function () {
        if (this.value.length >= 8) {
            $(this).parents('.form-group').find('.form__password-length').addClass('check');
        } else {
            $(this).parents('.form-group').find('.form__password-length').removeClass('check');
        }

        if (this.value.match(/[a-z]+/) && this.value.match(/[A-Z]+/)) {
            $(this).parents('.form-group').find('.form__password-letter').addClass('check');
        } else {
            $(this).parents('.form-group').find('.form__password-letter').removeClass('check');
        }


        if (this.value.match(/[0-9]+/)) {
            $(this).parents('.form-group').find('.form__password-number').addClass('check');
        } else {
            $(this).parents('.form-group').find('.form__password-number').removeClass('check');
        }
    });
}

function checkPassword() {
    $('input[type=password]').keyup(function () {
        var strength = 0;

        var val = $(this).val(), arr = [/.{8,}/, /[a-z]+/, /[0-9]+/, /[A-Z]+/];

        jQuery.map(arr, function (regexp) {
            if (val.match(regexp)) strength++;
        });

        $('.indicator').removeClass('active');
        for (i = 0; i < strength; i++) {
            $('.check-password .indicator').eq(i).addClass('active');
        }
    });
}

function inputFocus() {
    setupCodeInput('#smscode');
    setupCodeInput('#emailcode');
}

function setupCodeInput(containerSelector) {
    const inputs = $(`${containerSelector} .input-group-code .input-field`);

    inputs.on('input', function (e) {
        let val = $(this).val();
        if (!/^\d$/.test(val)) {
            $(this).val('');
            return;
        }

        let nextInput = $(this).parent().next('.input-group-code').find('.input-field');
        if (nextInput.length) {
            nextInput.focus();
        }
    });

    inputs.on('keydown', function (e) {
        if (e.key === 'Backspace' && !$(this).val()) {
            let prevInput = $(this).parent().prev('.input-group-code').find('.input-field');
            if (prevInput.length) {
                prevInput.focus().val('');
            }
        }
    });

    inputs.on('paste', function (e) {
        e.preventDefault();
        let pasteData = (e.originalEvent.clipboardData || window.clipboardData).getData('text');
        if (!/^\d{6}$/.test(pasteData)) return;

        let chars = pasteData.split('');
        inputs.each(function (index) {
            if (chars[index]) {
                $(this).val(chars[index]);
            }
        });

        inputs.last().focus();
    });
}

function copyValue() {
    $('.input-copy').keyup(function () {
        var target = $('.channelurl');

        target.text(RemoveAccents($(this).val()).replace(/\s+/g, '').toLowerCase());
    }).each(function () {
        var target = $('.channelurl');

        target.text(RemoveAccents($(this).val()).replace(/\s+/g, '').toLowerCase());
    });
}

function dzAudioURL() {
    $('#page-writepost-audio-url').on('keyup', function () {
        var fileExtension = ['mp3'];
        if ($.inArray($(this).val().split('.').pop().toLowerCase(), fileExtension) == -1) {

        } else {
            var sourcefile = $(this).val();
            $('audio.fc-media source').attr('src', sourcefile);
            dzMediaTag(sourcefile);
            dzRemoveIcon();
            audioplayer();
            $('.music-player').addClass('sys');

            $('.page-writepost-box-audio').addClass('show-player');
        }
    });

    $('.music-delete').click(function () {
        dzRemoveAudio();
        $('.music-player').removeClass('sys');
        $('.page-writepost-box-audio').removeClass('show-player');
        $('#page-writepost-audio-url').val('');
    });
}

function writePost() {
    const observer = new MutationObserver(() => {
        const divHeight = $('.writty-content').height();
        $('.writty-editor').css('min-height', divHeight + 'px');
    });

    const target = document.querySelector('.writty-content');
    if (target) {
        observer.observe(target, {
            childList: true,
            subtree: true
        });
    }

    $('.writty-content').on('click', function () {
        if ($('.writty-starttext').is(':visible')) {
            $('.writty-starttext').remove();
            $('#format-p').trigger('click');
        }
    });

    $('.writty-content').off('keyup').on('keyup', function (e) {
        const self = $(this);
        const textContent = $(self).text().trim();

        if (textContent.length > 0) {

        } else {
            $(this).attr('contenteditable', false);
            $(this).empty().append('<p><br></p>');
            $(this).attr('contenteditable', true);
            setTimeout(function () {
                $(self).focus();
            }, 100);
        }
    });

    $('.writty-content').on('paste', function () {
        const $this = $(this);

        $this.find('p').each(function () {
            const html = $(this).html().trim();

            if (html === '<br>' || html === '<br/>') {
                $(this).remove();
            }
        });
    });

    $('.page-writepost-button').click(function () {
        var target = $(this).attr('id');

        $('.page-writepost-button').removeClass('active');
        $(this).addClass('active');

        $('.page-writepost-box').removeClass('sys');
        $('.' + target).addClass('sys');

        switch (target) {
            case "page-writepost-box-image":
                if (!$('#dzupload-picture').hasClass('dz-clickable')) {
                    dropzonePictureUpload();
                }
                break;
            case "page-writepost-box-audio":
                if (!$('#dzupload-audio').hasClass('dz-clickable')) {
                    dropzoneAudioUpload();
                }
                break;
        }
    });

    $("#page-writepost-uploadimage").click(function () {
        writePostCloseAll();
    });

    $('.page-writepost-preview-close').click(function (e) {
        e.preventDefault();

        writePostClosePicture();
    });

    $('#page-writepost-youtube').click(function (e) {
        e.preventDefault();

        writePostCloseAll();

        $('.page-writepost-youtube-input').show().trigger('click');
        $('#page-writepost-youtube-url').focus();
    });

    $('#page-writepost-youtube-url').off();
    $('#page-writepost-youtube-url').on('keyup paste', function (e) {
        if (triggered == 0) {
            setTimeout(() => {
                var targetURL = $(this).val(), targetSplit = targetURL.split('watch?v='), targetSplitMobil = targetURL.split('https://youtu.be/');

                if (targetSplit[1]) {
                    targetYTID = targetSplit[1].slice(0, 11);
                }

                if (targetSplitMobil[1]) {
                    targetYTID = targetSplitMobil[1].slice(0, 11);
                }

                var realWidth = '';

                if (targetYTID != '') {
                    $('.page-writepost-youtube .page-writepost-preloader, .page-writepost-youtube').addClass('sys');
                    $('.page-writepost-youtube .page-writepost-preview-youtube').attr('src', '');
                    $('.page-writepost-youtube .page-writepost-preview-youtube').attr('src', 'https://i3.ytimg.com/vi/' + targetYTID + '/mqdefault.jpg').on('load', function () {
                        realWidth = this.width;
                    });
                    $('.page-writepost-youtube-input').removeClass('has-error has-value');

                    $('#page-writepost-youtubevideoid').val(targetYTID);
                    $('.page-writepost-youtube .post-video-thumbnail').show();
                    $('.page-writepost-youtube .dz-defaultcontent-img').hide();
                    $('.page-writepost-youtube .page-writepost-video-inner').addClass('sys');
                    $('.page-writepost-youtube .page-writepost-preloader').removeClass('sys');
                    $('.page-writepost-youtube .post-video-play').show();
                }

                triggered++;
            }, 0);
        }
    }).change(function () {
        triggered = 0;
    });

    $('.page-writepost-youtube .post-video-play').on('click', function () {
        var target = targetYTID;

        writePostCloseAll();

        $('.page-writepost-youtube').hide();
        $('.page-writepost-box-youtube .post-video-iframe .post-video-iframe-youtube').append('<iframe src="https://www.youtube.com/embed/' + target + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');

        $('.page-writepost-box-youtube .post-video-iframe').show();
    });

    $('.page-writepost-youtube-close').click(function (e) {
        e.preventDefault();

        $('.page-writepost-youtube .post-video-thumbnail').hide();
        $('.page-writepost-youtube .dz-defaultcontent-img').show();
        $('.page-writepost-youtube .page-writepost-video-inner').removeClass('sys');
        $('.page-writepost-youtube').show();
        $('.page-writepost-youtube-input').removeClass('has-error has-value');
        $('#page-writepost-youtube-url').val('');
        $('#page-writepost-youtubevideoid').val('');
        writePostCloseAll();
    });

    $('#page-writepost-vimeo-url').on('keyup paste', function () {
        setTimeout(() => {
            if (triggeredVimeo == 0) {
                var targetURL = $(this).val(), targetSplit = targetURL.split('/');

                targetVimeoID = +parseInt(targetSplit[3].slice(0, 10));

                $(".page-writepost-box-vimeo .page-writepost-error").hide();
                $(".page-writepost-preview-vimeo").attr("src", "https://vumbnail.com/" + targetVimeoID + ":3144c3edfc.jpg").attr("data-thumb", targetVimeoID);
                $(".page-writepost-box-vimeo .page-writepost-preloader, .page-writepost-box-vimeo .page-writepost-vimeo").addClass("sys");
                $("#page-writepost-vimeovideoid").val(targetVimeoID);
                $(".page-writepost-box-vimeo .page-writepost-preloader").removeClass("sys");
                $(".page-writepost-box-vimeo .post-video-play").show();
                triggeredVimeo++;

                var accessToken = '7e88d312a176fcf5ab1414191d655cd4';

                getVimeoThumbnail(targetVimeoID, accessToken);

                $('.page-writepost-vimeo .post-video-thumbnail').show();
                $('.page-writepost-vimeo .dz-defaultcontent-img').hide();
                $('.page-writepost-vimeo .page-writepost-video-inner').addClass('sys');
                $('.page-writepost-vimeo').hide();
                $('.post-video-iframe .post-video-iframe-vimeo').append('<iframe src="https://player.vimeo.com/video/' + targetVimeoID + '?h=aa2c6de7ab&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>');

                $('.page-writepost-box-vimeo .post-video-iframe').show();
            }
        }, 0);
    }).change(function () {
        triggeredVimeo = 0;
    });

    $('.page-writepost-vimeo .post-video-play').on('click', function () {
        var target = targetVimeoID;

        writePostCloseAll();

        $('.page-writepost-vimeo').hide();
        $('.post-video-iframe .post-video-iframe-vimeo').append('<iframe src="https://player.vimeo.com/video/' + target + '?h=aa2c6de7ab&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>');

        $('.page-writepost-box-vimeo .post-video-iframe').show();
    });

    $('.page-writepost-vimeo-close').click(function (e) {
        e.preventDefault();

        $('.page-writepost-vimeo .post-video-thumbnail').hide();
        $('.page-writepost-vimeo .dz-defaultcontent-img').show();
        $('.page-writepost-vimeo .page-writepost-video-inner').removeClass('sys');
        $('.page-writepost-vimeo').show();
        $('.page-writepost-vimeo-input').removeClass('has-error has-value');
        $('#page-writepost-vimeo-url').val('');
        $('#page-writepost-vimeovideoid').val('');
        writePostCloseAll();
    });


    $('.toolbar-image').click(function () {
        $('label[for="imageUpload"]').trigger('click');
    });

    $('#format-h2').click(function () {
        $(this).hide();
        $('#format-p').show();
    });

    $('#format-p').click(function () {
        $(this).hide();
        $('#format-h2').show();
    });

    $('.page-writepost input[type="radio"]').change(function () {
        let target = $(this).attr('id');

        $(this).parents('.chk-parent').find('.chk-contents .chk-content').slideUp().promise().done(function () {
            $(this).parents('.chk-parent').find('.chk-contents .chk-' + target).slideDown();
        });

    });

    $('.page-writepost input[type="checkbox"]').change(function () {
        if ($(this).prop('checked') == true) {
            if ($(this).parents('#chamlist').hasClass('has-error')) {
                $(this).parents('#chamlist').removeClass('has-error');
            }
        }
    });
}

function getVimeoThumbnail(videoId, userAccessToken) {
    $.ajax({
        url: 'https://api.vimeo.com/videos/' + videoId,
        type: 'GET',
        beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + userAccessToken);
        },
        success: function (response) {
            var thumbnailUrl = response.pictures.sizes[0].link;

            $('#thumbnail').attr('src', thumbnailUrl);
        },
        error: function (xhr, status, error) {
            console.error('Hiba tĂśrtĂŠnt a Vimeo API hĂ­vĂĄs sorĂĄn: ', status, error);
        }
    });
}

function writePostSend() {
    $('.btn-sendpost').click(function (e) {
        var image = $('#page-writepost-uploadimage').val(), video = $('#page-writepost-youtubevideoid').val(), title = $('#page-writepost-title').val(), content = $('.writty-content').html();

        $('.post-debug .post-debug-form').html(image + '<br/>' + video + '<br/>' + title);
        $('.post-debug .post-debug-content').text(content);
    });
}

function writePostClosePicture() {
    $('.page-writepost-preview').hide();
    $('.page-writepost-preview .page-writepost-preview-image').attr('src', '');
}

function writePostCloseYoutube() {
    $('.page-writepost-youtube .page-writepost-preview-youtube').attr('src', '');
    $('.page-writepost-youtube').removeClass('sys sys-full');
    $('#page-writepost-youtube-url').val('');
    $('#page-writepost-youtubevideoid').val('');
    triggered = 0;
}

function writePosteCloseIframe() {
    $('.page-writepost-box-youtube .post-video-iframe iframe').remove();
    $('.page-writepost-box-youtube .post-video-thumbnail iframe').remove();
    $('.page-writepost-box-youtube .post-video-iframe, .page-writepost-box-youtube .post-video-play').hide();
    $('.page-writepost-box-youtube .post-video-thumbnail .page-writepost-preview-youtube').attr('src', '').show();

}

function writePostCloseVimeo() {
    $('.page-writepost-vimeo .page-writepost-preview-vimeo').attr('src', '');
    $('.page-writepost-vimeo').removeClass('sys sys-full');
    $('#page-writepost-vimeo-url').val('');
    $('#page-writepost-vimeovideoid').val('');
    triggeredVimeo = 0;
}

function writePosteCloseIframeVimeo() {
    $('.page-writepost-box-vimeo .post-video-iframe iframe').remove();
    $('.page-writepost-box-vimeo .post-video-thumbnail iframe').remove();
    $('.page-writepost-box-vimeo .post-video-iframe, .page-writepost-box-vimeo .post-video-play').hide();
    $('.page-writepost-box-vimeo .post-video-thumbnail .page-writepost-preview-vimeo').attr('src', '').show();
}

function writePostCloseAll() {
    if ($('.page-writepost-preview').is(':visible')) {
        writePostClosePicture();
        writePosteCloseIframe();
        writePostCloseVimeo();
        writePosteCloseIframeVimeo();
    }

    if ($('.page-writepost-youtube').is(':visible')) {
        writePostCloseYoutube();
        writePosteCloseIframe();
    }

    if ($('.page-writepost-vimeo').is(':visible')) {
        writePostCloseVimeo();
        writePosteCloseIframeVimeo();
    }
}

function readImageURL(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
            $('.page-writepost-preview').show();
            $('.page-writepost-preview .page-writepost-preview-image').attr('src', e.target.result);
        };

        reader.readAsDataURL(input.files[0]);
    }
}

function tooltip() {
    $('body').on('click', '.tooltip-trigger', function () {
        let self = $(this), varText = self.data('text'), extraClass = "", leftPos;

        if ($('.tab').length) {
            extraClass = "tooltip-paywall";
        }

        $('html').append($('<div class="tooltip ' + extraClass + '"/>')
            .append($('<div class="tooltip-inner"/>')
                .append($('<div class="tooltip-content"/>')
                    .html(varText))));

        var varTextHeight = $('.tooltip').not('.tooltip-sys').height();


        setTimeout(function () {
            leftPos = self.offset().left - ($('.tooltip').width() - 20);

            if (leftPos < 0) {
                leftPos = 15;
            }

            $('.tooltip').not('.tooltip-sys').css({
                'top': self.offset().top - (varTextHeight + self.height()), 'left': leftPos, 'z-index': '999'
            });
        }, 100);

        bd.removeAttr('style').addClass('menu-open').show();
    });
}

function cretorSlider() {
    var $slider = $('.creator-slider');

    function fixCreatorSliderTabindex() {
        $slider.find('.slick-slide').attr('tabindex', '-1');
        $slider.find('.slick-slide a.creator-item, .slick-slide a.creator__item-link').attr('tabindex', '-1');
        $slider.find('.slick-slide.slick-active:not(.slick-cloned)').find('a.creator-item, a.creator__item-link').attr('tabindex', '0');
    }

    $slider.on('init setPosition afterChange breakpoint', function () {
        setTimeout(fixCreatorSliderTabindex, 0);
        resizeBoxes('.creator__item-title');
        fitTextToBox('.creator__item-header-text');
    });

    $slider.slick({
        infinite: true,
        draggable: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        dots: false,
        centerPadding: '0',
        speed: 400,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }, {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    fixCreatorSliderTabindex();
}

function dashboardSlider() {
    if ($('.dashboard-slider').children().length >= 2) {
        $('.dashboard-slider').slick({
            dots: true,
            draggable: false,
            arrows: false,
        });
    } else {
        $('.dashboard-slider').show();
    }
}

function dashboardSliderReinit() {
    $('.dashboard-slider').slick('unslick');
    $('.dashboard-slider #slider-barion').remove();
    $('.dashboard-slider').slick({
        infinite: false, draggable: false, arrows: false, speed: 0

    });
}

function dashboardSliderGoTo(slideno) {
    if (!$('.show-anyway').length) {
        var realId = $('.slider-' + slideno).data('index');

        if (realId !== undefined) {
            $('.dashboard-slider').slick('slickGoTo', realId);
        } else {
            $('.dashboard-slider').slick('destroy');
            $('.dashboard-slider').parents('.rounded-box').hide();
        }
    }
}

function pageDashboard() {
    if ($('.pd__box-item').length) {
        resizeBoxes('.pd__box-item-title');
        resizeBoxes('.pd__box-item-text');
    }
}

function donationSlider(view) {
    $('.fanpage-donations-slider').on('init', function (i, c) {
        resizeBoxes('.fanpage-donations-slider .fanpage-box-title');
    }).each(function (i, v) {
        let slideToShow = 3;
        if ($(v).hasClass('slick-initialized')) {
            $(v).slick('unslick');
        }

        if (view) {
            slideToShow = 2;
        }

        if ($(v).find('.fanpage-box').length > 1) {
            let slickOptions = {
                infinite: false,
                draggable: false,
                slidesToShow: slideToShow,
                slidesToScroll: slideToShow,
                arrows: true,
                dots: false,
                speed: 400,
                centerMode: false,
                initialSlide: 0,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            draggable: true
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            infinite: true,
                            slidesToShow: 1.2,
                            slidesToScroll: 1,
                            arrows: true,
                            dots: true,
                            draggable: true
                        }
                    }
                ]
            };

            if ($(this).hasClass('fanpage-donations-slider-nomobil')) {
                slickOptions.responsive.push({
                    breakpoint: 576,
                    settings: 'unslick'
                });
            }

            $(this).slick(slickOptions);
        } else {
            $(v).addClass('only-one');
        }
    });


    $('.show-more-button').on('click', function () {
        let more = $(this).data('more');
        let less = $(this).data('less');
        let target = $(this).data('target');

        let $container;

        if (target) {
            $container = $(target);
        } else {
            $container = $('.fanpage-donations-slider-nomobil');
        }

        if ($container.length) {
            $container.toggleClass('show-all');

            if (!$('.fanpage-box-v2').length) {
                fanpageDescription();
            }

            if (!$container.hasClass('show-all')) {
                $('html, body').animate({
                    scrollTop: $container.offset().top - 20
                }, 500);
            }

            $(this).find('span.text').text(function (i, text) {
                return text === more ? less : more;
            });
        }
    });
}

function donationPage() {
    $('.js-show-inactives').click(function () {
        if (!$(this).hasClass('active')) {
            $(this).addClass('active');
            $('.profil-inactive-blocks').slideDown();
        } else {
            $(this).removeClass('active');
            $('.profil-inactive-blocks').slideUp();
        }
    });
}


function sendMessage() {
    $('input[name="for-who"]').on('change', function () {
        if ($(this).attr('id') == 'depends-on-support') {
            $('#form-support .form-group').slideDown();
            $('#form-support .form-group input').attr('required', 'required');
        } else {
            $('#form-support .form-group').slideUp();
            $('#form-support .form-group input').removeAttr('required');
            $('#form-support .form-group input').prop('checked', false);
        }
    });
}

function readpostComment() {
    $(".readpost__comment-text").on("focus", function () {
        let self = $(this);

        self.parents('.readpost__comment').addClass('on-focus');

        let placeholder = self.find("p.placeholder");
        if (placeholder.length > 0) {
            placeholder.remove();

            self.html("<p><br></p>");

            let range = document.createRange();
            let sel = window.getSelection();
            let newParagraph = self.find("p")[0];
            range.setStart(newParagraph, 0);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (self.text().trim() === "") {
            self.html("<p><br></p>");

            let range = document.createRange();
            let sel = window.getSelection();
            let newParagraph = self.find("p")[0];
            range.setStart(newParagraph, 0);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        }
    }).on("keydown", function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();

            let newParagraph = $("<p>&nbsp;<br>&nbsp;</p>");
            $(this).find("p").last().after(newParagraph);

            let range = document.createRange();
            let sel = window.getSelection();
            range.setStart(newParagraph[0], 0);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        }

    }).on("keyup", function (e) {
        if (e.keyCode === 8 || e.keyCode === 46) {
            let self = $(this);

            if (self.text().trim() === "" && self.find("p").length === 0) {
                self.html("<p><br></p>");

                let range = document.createRange();
                let sel = window.getSelection();
                let newParagraph = self.find("p")[0];
                range.setStart(newParagraph, 0);
                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }
    }).on("paste", function (e) {
        e.preventDefault();

        let self = $(this);
        let clipboardData = e.originalEvent.clipboardData || window.clipboardData;
        let pastedText = clipboardData.getData('text/plain');

        if (pastedText) {
            let cleanText = pastedText.replace(/\n/g, ' ').replace(/\r/g, ' ');

            let selection = window.getSelection();
            if (selection.rangeCount > 0) {
                let range = selection.getRangeAt(0);
                range.deleteContents();
                let textNode = document.createTextNode(cleanText);
                range.insertNode(textNode);

                range.setStartAfter(textNode);
                range.collapse(true);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.readpost__comment').length) {
            $('.readpost__comment').removeClass('on-focus');
            createPlaceholder();
        }
    });

    $('.js-write-comment').on('click', function () {
        $('html, body').animate(function () {
            scrollTop: $('#ajax-post-comments').offset().top - $('.navbar').height();
        }, 500);
    });
}

function createPlaceholder() {
    let placeholder = $(".readpost__comment-text").data('placeholder');

    if ($(".readpost__comment-text").text().trim() === "") {
        if ($(".readpost__comment-text").find("p.placeholder").length === 0) {
            $(".readpost__comment-text").html('<p class="placeholder">' + placeholder + '</p>');
        }
    }
}

function fanpageDonationList() {
    var boxNumber = $('.fanpage-donations .fanpage-box').length;

    if (boxNumber >= 4) {
        $('.btn-showall').addClass('sys');
    }

    $('body').on('click', '.btn-showall', function () {
        if ($(this).parents('.popup-content').length) {
            $(this).parents('.popup-content').find('.fanpage-donations-more').slideDown();
            $(this).parents('.popup-content').find('.btn-showless').addClass('sys');
        }
        if ($(this).parents('.page-fanpage').length) {
            $(this).parents('.page-fanpage').find('.fanpage-donations-more').slideDown();
            $(this).parents('.page-fanpage').find('.btn-showless').addClass('sys');
        }
        $(this).removeClass('sys');
    });

    $('body').on('click', '.btn-showless', function () {
        if ($(this).parents('.popup-content').length) {
            $(this).parents('.popup-content').find('.fanpage-donations-more').slideUp();
            $(this).parents('.popup-content').find('.btn-showall').addClass('sys');
        }
        if ($(this).parents('.page-fanpage').length) {
            $(this).parents('.page-fanpage').find('.fanpage-donations-more').slideUp();
            $(this).parents('.page-fanpage').find('.btn-showall').addClass('sys');
        }

        $(this).removeClass('sys');

    });
}

function fanpageDescription() {
    $('.fanpage-description .show-more, .fanpage-description .show-less, .fanpage-description .show-more-mobil, .fanpage-description .show-less-mobil').remove();
    $('.fanpage-description').removeClass('hys hys-mobil sys show-hide-mobil').css('height', '');

    $('.show-more, .show-less, .show-more-mobil, .show-less-mobil').off('click');

    $('.fanpage-donations .fanpage-box .fanpage-description').each(function (i, v) {
        var moreText = $(v).data('more'),
            lessText = $(v).data('less');
        var moreTextNMobil = $(v).data('more-mobil'),
            lessTextMobil = $(v).data('less-mobil');

        if (WW >= 576) {
            if ($(v).height() >= 107) {
                $(v).addClass('hys');
                $(v).append('<button class="show-more h4">' + moreText + '</button>');
                $(v).append('<button class="show-less h4 hys">' + lessText + '</button>');

                setTimeout(function () {
                    $('.fanpage-donations .fanpage-box .fanpage-description').height('107');
                }, 100);
            }
        } else {
            if ($(v).height() >= 107) {
                $(v).addClass('hys-mobil');
                $(v).append('<button class="show-more-mobil h4">' + moreTextNMobil + '</button>');
                $(v).append('<button class="show-less-mobil h4 hys">' + lessTextMobil + '</button>');
            }
        }
    }).promise().done(function () {
        $('.fanpage-donations-more').hide();
    });

    $(document).on('click', '.show-more', function () {
        var el = $(this),
            elCurrentHeight = el.parent().height(),
            elAutoHeight = el.parent().css('height', 'auto').height();
        el.parent().height(elCurrentHeight).animate({height: elAutoHeight}, 400);
        el.parent().addClass('sys');
        el.hide();
        setTimeout(function () {
            el.parent().find('.show-less').fadeIn();
        }, 300);
    });

    $(document).on('click', '.show-less', function () {
        var el = $(this),
            elCurrentHeight = el.parent().height();
        el.parent().height(elCurrentHeight).animate({height: 107}, 400);
        el.parent().removeClass('sys');
        el.hide();
        setTimeout(function () {
            el.parent().find('.show-more').fadeIn();
        }, 300);
    });

    $(document).on('click', '.show-more-mobil', function () {
        $(this).parent('.fanpage-description').find('.fanpage-box-content-v1-desc').addClass('sys');
        $(this).parent('.fanpage-description').addClass('show-hide-mobil');
    });

    $(document).on('click', '.show-less-mobil', function () {
        var $this = $(this);
        $this.parent('.fanpage-description').find('.fanpage-box-content-v1-desc').removeClass('sys');
        $this.parent('.fanpage-description').removeClass('show-hide-mobil');
        $('html, body').animate({
            scrollTop: $this.parents('.fanpage-box').offset().top - 50
        }, 1000);
    });
}

function fanpageMobil() {
    function getLuminance(r, g, b) {
        const toLinear = (channel) => {
            const c = channel / 255;
            return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
        };

        const R = toLinear(r);
        const G = toLinear(g);
        const B = toLinear(b);

        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }

    function getContrastRatio(rgb1, rgb2) {
        const lum1 = getLuminance(...rgb1);
        const lum2 = getLuminance(...rgb2);
        const lighter = Math.max(lum1, lum2);
        const darker = Math.min(lum1, lum2);
        return ((lighter + 0.05) / (darker + 0.05));
    }

    function adjustWhiteForContrast(bgRgb, minRatio = 3.0) {
        let value = 255;

        while (value > 0) {
            const white = [value, value, value];
            const contrast = getContrastRatio(bgRgb, white);
            if (contrast >= minRatio) {
                return white;
            }
            value -= 5;
        }

        return [0, 0, 0];
    }

    function getDominantColor(imgElement) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = imgElement.naturalWidth;
        canvas.height = imgElement.naturalHeight;

        ctx.drawImage(imgElement, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const pixels = imageData.data;

        const colorCount = {};

        for (let i = 0; i < pixels.length; i += 4) {
            const r = pixels[i];
            const g = pixels[i + 1];
            const b = pixels[i + 2];
            const a = pixels[i + 3];

            if (a < 128) continue;

            const color = `${r},${g},${b}`;
            colorCount[color] = (colorCount[color] || 0) + 1;
        }

        const isWhiteish = ([r, g, b]) => r > 240 && g > 240 && b > 240;
        const isBlackish = ([r, g, b]) => r < 15 && g < 15 && b < 15;

        const filteredColors = Object.entries(colorCount).filter(([color]) => {
            const [r, g, b] = color.split(',').map(Number);
            return !isWhiteish([r, g, b]) && !isBlackish([r, g, b]);
        });

        const sortedColors = (filteredColors.length > 0 ? filteredColors : Object.entries(colorCount))
            .sort((a, b) => b[1] - a[1]);

        let [r, g, b] = sortedColors[0][0].split(',').map(Number);

        const lighten = (v) => Math.round(v + (255 - v) * 0.2);
        r = lighten(r);
        g = lighten(g);
        b = lighten(b);

        return [r, g, b];
    }

    function showDonationsSlider() {
        const sliderCtn = document.querySelector('.fanpage-donations-slider-nomobil');
        if (sliderCtn) {
            sliderCtn.style.display = 'block';
        }
    }


    function sameOriginImageSrc(src) {
        try {
            const url = new URL(src, window.location.href);
            if (url.origin === window.location.origin) {
                return null;
            }
            return window.location.origin + url.pathname + url.search;
        } catch (e) {
            return null;
        }
    }

    function analyzeImages() {
        const images = document.querySelectorAll('.fanpage-box-cover');

        images.forEach(img => {
            const applyRgb = (rgb) => {
                const bgColor = `rgb(${rgb.join(',')})`;

                const contrastWithWhite = getContrastRatio(rgb, [255, 255, 255]);
                let textColor = 'rgb(255,255,255)';

                const parent = img.closest('.fanpage-box-inner');
                if (parent) {
                    parent.style.backgroundColor = bgColor;

                    if (contrastWithWhite < 3.0) {
                        const adjustedWhite = adjustWhiteForContrast(rgb, 3);
                        textColor = `rgb(${adjustedWhite.join(',')})`;
                        const title = parent.querySelector('.fanpage-box-title');
                        const amount = parent.querySelector('.fanpage-amount');
                        const monthly = parent.querySelector('.fanpage-amount > .fanpage-monthly');
                        const description = parent.querySelector('.fanpage-description');
                        const svgElement = parent.querySelector('.fanpage-box-toggler > .fanpage-box-toggler-svg');

                        if (title) title.style.color = textColor;
                        if (amount) amount.style.color = textColor;
                        if (monthly) monthly.style.color = textColor;
                        if (description) description.style.color = textColor;
                        if (svgElement) svgElement.style.fill = textColor;

                    }
                    showDonationsSlider();
                }
            };

            const applyColor = (source) => {
                if (!img.dominantRgb) {
                    try {
                        img.dominantRgb = getDominantColor(source);
                    } catch (e) {
                        // tainted canvas / betöltetlen kép: szín nélkül megyünk tovább,
                        // de a slider ettől még jelenjen meg
                        showDonationsSlider();
                        return;
                    }
                }
                applyRgb(img.dominantRgb);
            };

            const localSrc = sameOriginImageSrc(img.currentSrc || img.src);

            if (img.dominantRgb) {
                applyColor(img);
            } else if (localSrc) {
                const sampler = new Image();
                sampler.onload = () => applyColor(sampler);
                sampler.onerror = () => showDonationsSlider();
                sampler.src = localSrc;
            } else if (img.complete) {
                applyColor(img);
            } else {
                img.addEventListener('load', () => applyColor(img));
                img.addEventListener('error', showDonationsSlider);
            }
        });
    }

    analyzeImages();

    setTimeout(function () {
        $('.fanpage-box-v2').each(function (i, v) {
            $(v).find('.fanpage-description').removeClass('hys-mobil');
            $(v).find('.show-more-mobil').remove();
            $(v).find('.show-less-mobil').remove();

        });
    }, 400);

    $(document).off('click', '.fanpage-box-toggler').on('click', '.fanpage-box-toggler', function () {
        const $toggler = $(this);
        const $inner = $toggler.closest('.fanpage-box-inner');
        const $description = $inner.find('.fanpage-description');

        if (!$toggler.hasClass('active')) {
            $toggler.addClass('active');
            $description.stop(true, true).slideDown();
        } else {
            $description.stop(true, true).slideUp();
            $toggler.removeClass('active');
        }
    });
}

function showFanpageShare() {
    $('.show-fanpageshare').click(function (e) {
        e.preventDefault();


        if (!$('.fanpage-submenu').hasClass('sys')) {
            $('.fanpage-submenu').removeAttr('style');

            if (WW >= 576) {
                $('.fanpage-submenu').css('left', $(this).position().left);
            } else {
                if ($('.fanpage-social-bottom .btn-border').length) {
                    $('.fanpage-submenu').css('top', '146px');
                }
            }

            $('.fanpage-submenu').addClass('sys');
            bd.addClass('menu-open').show();
        }
    });
}

function postList() {
    $('.post-list .post-item').each(function (i, v) {
        if ($(v).find('.music-player').length) {
            audioplayer();
        }
    });
}

function postReadmore() {
    $('.post-item .post-text').each(function (i, v) {
        var moreText = $(v).data('more'), lessText = $(v).data('less');

        if ($(v).height() >= 300) {
            $(v).addClass('hys');
            $(v).append('<button class="show-more h4">' + moreText + '</button>');
            $(v).append('<button class="show-less h4 hys">' + lessText + '</button>');
        }
    });

    $('.show-more').on('click', function () {
        var el = $(this), elCurrentHeight = el.parent().height(), elAutoHeight = el.parent().css('height', 'auto').height();

        el.parents('.post-item').addClass('sys');

        el.parent().height(elCurrentHeight).animate({height: elAutoHeight}, 400);
        el.parent().addClass('sys');
        el.hide();
        setTimeout(function () {
            el.parent().find('.show-less').fadeIn();

        }, 300);
    });

    $('.show-less').on('click', function () {
        var el = $(this), elCurrentHeight = el.parent().height();

        el.parent().height(elCurrentHeight).animate({height: 300}, 400);
        el.parent().removeClass('sys');
        el.hide();

        setTimeout(function () {
            el.parent().find('.show-more').fadeIn();
            el.parents('.post-item').removeClass('sys');
        }, 300);
    });
}

function postVideoEmbed() {
    $('body').on('click', '.post-video-thumbnail', function () {
        var target = $(this).data('code'), targetVimeo = $(this).data('vimeocode'), parentHeight = $(this).find('.img-resp').height();

        $(this).find('.page-writepost-preview-youtube').hide();

        if ($(this).parents('.post-item').length || $(this).parents('.readpost-header').length) {
            $(this).find('img.img-resp').remove();
            $(this).find('.post-video-play').remove();
        }
        if (!$(this).find('iframe').length) {
            if (target != '' && targetVimeo == '') {
                $(this).append('<iframe src="https://www.youtube.com/embed/' + target + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" height="' + parentHeight + '" allowfullscreen></iframe>');
            }

            if (targetVimeo != '' && target == '') {
                $(this).append('<div class="post-video-iframe-vimeo" style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/' + targetVimeo + '?h=aa2c6de7ab&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div>');
            }
        }
    });
}

function postVideoThumbnail() {
    $('.post-item .post-video-thumbnail').each(function (i, v) {
        var ytID = $(v).data('code'), realWidth = '', vimeoID = $(v).data('vimeocode');

        if (ytID) {
            $(v).find('.img-resp').attr('src', 'https://i3.ytimg.com/vi/' + ytID + '/mqdefault.jpg').on('load', function () {
                realWidth = this.width;
            });
        }

        if (vimeoID) {
            $.ajax({
                type: 'GET',
                url: 'https://vimeo.com/api/v2/video/' + vimeoID + '.json',
                jsonp: 'callback',
                data: 'json',
                success: function (data) {
                    var thumbnail_src = data[0].thumbnail_large;
                    $(v).find('.img-resp').attr('src', thumbnail_src);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                }
            });
        }
    });
}

function backdrop() {
    $(document).on('keyup', function (e) {
        if (e.keyCode == 27) {
            if ($('.backdrop').is(':visible')) {
                bd.trigger('click');
            }
        }
    });

    $('.backdrop').click(function () {
        releasePopupFocusTrap();

        $('.popup, .preview').removeAttr('style').removeClass('active');

        bd.fadeOut();
        if ($('.autocomplete').is(':visible')) {
            $('.autocomplete').hide();
        }

        if ($('html').hasClass('menu-open')) {
            $('html').removeClass('menu-open');
        }

        if ($('.submenu').hasClass('sys')) {
            $('.submenu').removeClass('sys');
        }

        if ($('.fanpage-submenu').hasClass('sys')) {
            $('.fanpage-submenu').removeClass('sys');
        }

        setTimeout(function () {
            bd.removeClass('sys menu-open').removeAttr('style');
            $('.popup').removeClass('higher-then-window');
        }, 400);

        if ($('.tooltip').length) {
            $('.tooltip').remove();
        }

        if ($('.picture-container-package').hasClass('croppie-container')) {
            $('.picture-container-package').croppie('destroy');
        }
    });
}

var lastPopupTrigger = null;

function trapPopupFocus($popup) {
    releasePopupInert();

    var el = $popup.get(0);
    while (el && el !== document.body) {
        $(el).siblings().each(function () {
            if ($(this).is('.backdrop, .popup, .preview') || this.hasAttribute('data-popup-inert')) {
                return;
            }
            this.inert = true;
            this.setAttribute('data-popup-inert', '');
        });
        el = el.parentNode;
    }
}

function releasePopupInert() {
    $('[data-popup-inert], .popup, .preview').each(function () {
        this.inert = false;
        this.removeAttribute('data-popup-inert');
    });
}

function releasePopupFocusTrap() {
    releasePopupInert();
    if (lastPopupTrigger) {
        $(lastPopupTrigger).focus();
        lastPopupTrigger = null;
    }
}

function focusFirstInPopup($popup) {
    var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var $focusable = $popup.find(focusableSelector).filter(':visible').filter(function () {
        return !$(this).is('.popup-close, .popup-dismiss, .popup-btnclose, .preview-close, .popup-back') &&
            $(this).closest('.popup-close, .popup-btnclose, .preview-close').length === 0;
    });
    var el = $focusable.first()[0];

    if (el) {
        el.focus();

        var selectableTypes = ['text', 'search', 'url', 'tel', 'password', 'email'];
        var isTextField = el.tagName === 'TEXTAREA' ||
            (el.tagName === 'INPUT' && selectableTypes.indexOf((el.type || 'text').toLowerCase()) !== -1);
        if (isTextField && typeof el.select === 'function') {
            try {
                el.select();
            } catch (err) {
            }
        }
    }
}

function popup() {
    $(doc).on('click', '.show-popup', function (e) {
        e.preventDefault();

        var target = $(this).data('target'), windowHeight = $(window).height(), popupHeight = $('.popup-' + target).outerHeight();

        $('.popup-' + target).removeClass('higher-then-window');

        if (popupHeight >= (windowHeight - 150)) {
            $('.popup-' + target).addClass('higher-then-window');

            setTimeout(function () {
                $('.popup-' + target).css('top', $(window).scrollTop() + $('.navbar').height() + 40);
            }, 200);
        }

        $('.popup').removeClass('active');
        bd.removeClass('menu-open');

        if ($('#package-pic-upload').length) {
            packagePicture();
        }

        $('.popup-' + target).addClass('active');
        $('.submenu').removeClass('sys');

        bd.fadeIn();

        if ($('html').hasClass('menu-open')) {
            $('html').removeClass('menu-open');
        }

        lastPopupTrigger = this;
        var $activePopup = $('.popup-' + target);
        setTimeout(function () {
            trapPopupFocus($activePopup);
            focusFirstInPopup($activePopup);
        }, 50);
    }).on('click', '.popup-close, .popup-dismiss, .popup-btnclose, .preview-close', function () {
        releasePopupFocusTrap();
        bd.fadeOut();
        $('.popup, .preview').removeClass('active');
        setTimeout(function () {
            bd.removeClass('sys');
        }, 400);

        if ($('.picture-container-package').hasClass('croppie-container')) {
            $('.picture-container-package').croppie('destroy');
        }

        if ($(this).parents('.preview-preview').length) {
            $('.preview-tabs-item[data-size="1240"]').trigger('click');

        }

    }).on('click', '.popup-back', function () {
        $(this).parents('.popup-inner').find('.group-container .input-field').val('');
        $(this).parents('.popup-inner').find('.popup-content').removeAttr('style');

        if ($('.forms').hasClass('show-activation')) {
            $('.forms').removeClass('show-activation');
            $(this).removeClass('sys');
        }

        if ($('.popup-content').hasClass('doanim')) {
            $('.popup-content').removeClass('doanim');
            $(this).removeClass('sys');
        }
    });
}

function showPopup(target) {
    var windowHeight = $(window).height(), popupHeight = $('.popup-' + target).outerHeight();

    $('.popup-' + target).removeClass('higher-then-window');

    if (popupHeight >= (windowHeight - 200)) {
        $('.popup-' + target).css('top', $(window).scrollTop() + $('.navbar').height() + 40).addClass('higher-then-window');
    }

    $('.popup').removeClass('active');
    $('.popup-' + target).addClass('active');

    bd.fadeIn();
}

function pageCompare() {
    $('.d-tab-item').click(function () {
        var target = $(this).data('target');

        $('.d-tab-item').removeClass('active');
        $(this).addClass('active');

        $('.d-tab-container').hide();
        $('#' + target).show();
    });

}

function pageDonations() {
    $('.show-older').click(function (e) {
        e.preventDefault();

        $('.donation-older .hys').removeClass('hys');
    });
}

function pageReadPost() {
    $('.readpost-donation-showmore').click(function () {
        $(this).hide();
        $('.readpost-donation').show();
    });
}

function pageSendMessage() {
    new EmojiPicker({
        trigger: [
            {
                selector: '.js-showemojis',
                insertInto: '.pm__conversation-message'
            }
        ],
        closeButton: true
    });

    $('.page-message-email .chk-container-parent input').change(function () {
        $('.page-message-email .chk-content').slideUp();
        $('.page-message-email .chk-content input').removeAttr('required');
        $('.page-message-email .chk-content input').removeAttr('checked');
        $(this).parents('.form-group').find('.chk-content').slideDown();
        $(this).parents('.form-group').find('.chk-content input').attr('required', 'required');
    });
}

function pageSettings() {
    componentsTab();

    $('#content_creator').on('change', function () {
        if ($(this).prop('checked') == true) {
            showPopup('writer');
        }
    });

    $('#disabled-writer').on('click', function () {
        $('#content_creator').prop('checked', false).trigger('change');
    });

    $('#enable-writer').on('click', function () {
        $(doc).animate({'scrollTop': $('.ps__buttons').offset().top - $('.navbar').height() - 60}, 1000);
    });
}

function componentsTabScrollToActive(navItem) {
    if (!navItem || !navItem.length) {
        return;
    }

    const nav = navItem.closest('.pd__box-nav').get(0);
    const item = navItem.get(0);

    if (!nav || nav.scrollWidth <= nav.clientWidth) {
        return;
    }

    const navRect = nav.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    const targetLeft = nav.scrollLeft + (itemRect.left - navRect.left) - (navRect.width - itemRect.width) / 2;

    nav.scrollLeft = Math.max(0, Math.min(targetLeft, nav.scrollWidth - nav.clientWidth));
}

function componentsTab() {
    $('.pd__box-nav-item').click(function () {
        let target = $(this).data('target');

        if (target != 'paywall') {
            if (!$(this).hasClass('active')) {
                $('.pd__box-nav-item').removeClass('active');
                $(this).addClass('active');

                $('.pd__box-content').hide();
                $('#' + target).show();
            }


            const url = new URL(window.location);
            url.searchParams.set('tab', target);
            window.history.replaceState({}, '', url);
        }
    });

    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');
    if (tabParam) {
        const targetNav = $('.pd__box-nav-item[data-target="' + tabParam + '"]');
        if (targetNav.length) {
            $('#subpage_name').text(targetNav.text());
            $('.pd__box-nav-item').removeClass('active');
            targetNav.addClass('active');
            $('.ps__tab').hide();
            $('#' + tabParam).show();
            componentsTabScrollToActive(targetNav);
            initTextTruncation();
            return;
        }
    }

    const activeNav = $('.pd__box-nav-item.active');
    if (activeNav.length) {
        const activeTarget = activeNav.data('target');
        $('#subpage_name').text(activeNav.text());
        $('.ps__tab').hide();
        $('#' + activeTarget).show();
        componentsTabScrollToActive(activeNav);
    }
}

function postGallery() {
    document.querySelectorAll('.readpost-content img').forEach(function (img) {
        if (!img.closest('[data-fancybox]')) {
            img.setAttribute('data-fancybox', 'cikk-gallery');
        }
    });

    Fancybox.bind('[data-fancybox]', {
        Toolbar: {
            display: {
                left: ['infobar'],
                middle: [],
                right: ['close']
            }
        },
        Thumbs: {
            type: 'classic',
            showOnStart: true
        }
    });
}

function RemoveAccents(strAccents) {
    var strAccents = strAccents.split('');
    var strAccentsOut = new Array();
    var strAccentsLen = strAccents.length;
    var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽžőű';
    var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZzou";
    for (var y = 0; y < strAccentsLen; y++) {
        if (accents.indexOf(strAccents[y]) != -1) {
            strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
        } else
            strAccentsOut[y] = strAccents[y];
    }
    strAccentsOut = strAccentsOut.join('');
    return strAccentsOut;
}

function resizeBoxes(boxes) {
    if ($.type(boxes) === 'string') boxes = $(boxes);

    var h = 0;
    boxes.height('auto');
    boxes.each(function () {
        if ($(this).height() > h) h = $(this).height();
    });


    if (boxes.hasClass('form-reg')) {
        boxes.height(h + 40);
    } else {
        boxes.height(h);
    }

}

function countTextLines(el) {
    var range = document.createRange(),
        rects, lines = 0, i;

    range.selectNodeContents(el);
    rects = range.getClientRects();

    // Soronkent egy rect, de a 0 magassagu / szelessegu darabokat kiszurjuk
    for (i = 0; i < rects.length; i++) {
        if (rects[i].height > 0 && rects[i].width > 0) {
            lines++;
        }
    }

    range.detach();

    return lines;
}

// A creator header cim maximalis betumerete breakpointonkent
function fitTextToBoxMaxSize() {
    var ww = $(window).width();

    if (ww <= 575) {
        return 24;
    }

    if (ww <= 992) {
        return 32;
    }

    return 43;
}

function fitTextToBox(boxes, maxSize, minSize, maxLines) {
    if ($.type(boxes) === 'string') boxes = $(boxes);

    // Defaultok a 152px-es creator header dobozhoz: max 2 sor, de ne vagjuk le
    maxSize = maxSize || fitTextToBoxMaxSize();
    minSize = minSize || 16;
    maxLines = maxLines || 2;

    boxes.each(function () {
        var el = this,
            $el = $(el),
            limit = $el.parent().height(),
            size = maxSize;

        // Rejtett vagy magassag nelkuli doboznal nincs mit merni
        if (!limit) {
            return;
        }

        $el.css('font-size', size + 'px');

        // Ket feltetel: ferjen bele a dobozba (offsetHeight tartalmazza a sajat
        // paddingjat is), es ne legyen tobb a megadott sorszamnal
        while (size > minSize && (el.offsetHeight > limit || countTextLines(el) > maxLines)) {
            size--;
            $el.css('font-size', size + 'px');
        }
    });
}

function minResizeBoxes(boxes) {
    if ($.type(boxes) === 'string') boxes = $(boxes);

    var h = 0;
    boxes.minHeight('auto');
    boxes.each(function () {
        if ($(this).minHeight() > h) h = $(this).minHeight();
    });
    boxes.minHeight(h);
}

function getOS() {
    var a = '';
    var osString = {
        'windows': /(Win)/, 'android': /Android/, 'linux': /(Linux|X11)/, 'ios': /(iPhone|iPad|iPod|Mac)/, 'unix': /UNIX/, 'bot': /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
    };

    $.each(osString, function (k, v) {
        if (a == '' && v.test(navigator.userAgent)) a = k;
    });
    return a;
}

function getBrowser() {
    var a = '';
    var browserString = {
        'Chrome': 'chrome', 'MSIE': 'ie', 'Trident/': 'ie', 'Firefox': 'ff', 'Safari': 'safari', 'Presto': 'opera', 'Opera': 'opera'
    };
    $.each(browserString, function (k, v) {
        if (a == '' && navigator.userAgent.indexOf(k) != '-1') a = v;
    });
    return a;

}

if (os == 'ios' && browser == 'safari') {
    (function (doc) {
        var addEvent = 'addEventListener', type = 'gesturestart', qsa = 'querySelectorAll', scales = [1, 1], meta = qsa in doc ? doc[qsa]('meta[name=viewport]') : [];

        function fix() {
            meta.content = 'width=device-width,minimum-scale=' + scales[0] + ',maximum-scale=' + scales[1];
            doc.removeEventListener(type, fix, true);
        }

        if ((meta = meta[meta.length - 1]) && addEvent in doc) {
            fix();
            scales = [0.25, 1.6];
            doc[addEvent](type, fix, true);
        }
    }(document));
}

if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var msViewportStyle = document.createElement("style");
    msViewportStyle.appendChild(document.createTextNode("@-ms-viewport{width:auto!important}"));
    document.getElementsByTagName("head")[0].appendChild(msViewportStyle);
}

var running = false;

var ifInPage = function isScrolledIntoView(elm, visibilityCheck) {
    visibilityCheck = visibilityCheck || "visible";
    var vpH = $(window).height(),
        st = $(window).scrollTop(),
        y = $(elm).offset().top, elementHeight = $(elm).height();

    if (visibilityCheck == "visible") return ((y < (vpH + st)) && (y > (st - elementHeight)));
    if (visibilityCheck == "above") return ((y < (vpH + st)));
}, animateScroll = function () {
    if (!running) {
        if ($('.chart_anim').length > 0) {
            $('.chart_anim').each(function () {
                running = true;

                if (ifInPage($(this))) {
                    var self = $(this);

                    self.addClass('s1');
                }
            });
        }

        if ($('.animated').length > 0) {
            $('.animated').each(function () {
                running = true;

                if (ifInPage($(this))) {
                    var self = $(this);
                    self.addClass('go');
                }
            });
        }
        running = false;
    }
}, running = false;


